import React from 'react'

import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import { useParams } from 'react-router'
import { fetchSingle } from 'src/legacy_modules/entities/template/request'
import { useRequestState } from 'src/legacy_modules/server/use-request-state'
import { ModalCancelButton } from 'src/lib/chakra-theme/components'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'

import { submitTemplateEnable } from './request'
import { trialIdParamName } from '../../../../../trial-detail'
import { useTemplateEntities } from '../../../../template-entities-context'
import { templateIdParamName } from '../../template-detail'

type Props = {
  onClose: () => void
}

export const EnableContainer: React.FC<Props> = props => {
  const { trialUid = '', templateUid = '' } = useParams<{
    [templateIdParamName]: string
    [trialIdParamName]: string
  }>()

  const { getTemplate, upsertTemplate } = useTemplateEntities()
  const template = getTemplate(templateUid)

  const { request, requesting } = useEnableTemplate({
    trialUid,
    templateUid,
  })

  const toast = useMirohaToast()

  const onSubmit = () => {
    const submit = async () => {
      try {
        await request()
        const updated = await fetchSingle({ trialUid, templateUid })
        upsertTemplate(updated)
        toast({
          status: 'success',
          title: 'テンプレートを有効化しました。',
        })
        props.onClose()
      } catch (error) {
        toast({
          status: 'error',
          title: error.message,
        })
      }
    }

    submit()
  }

  if (!template) return null

  return (
    <Modal isOpen onClose={props.onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>テンプレートを有効化</ModalHeader>
        <ModalBody>
          <Text>
            <Text fontWeight="bold" as="span">
              {template.title}
            </Text>
            を有効化します。
          </Text>
        </ModalBody>
        <ModalFooter>
          <ModalCancelButton />
          <Button onClick={onSubmit} isDisabled={requesting}>
            有効化する
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

const useEnableTemplate = ({
  trialUid,
  templateUid,
}: {
  trialUid: string
  templateUid: string
}) => {
  const {
    requestDone,
    requestFailed,
    requestStarted,
    requesting,
    errorMessage,
  } = useRequestState()

  const request = async () => {
    try {
      requestStarted()
      await submitTemplateEnable({ trialUid, templateUid })
      requestDone()
    } catch (error) {
      requestFailed(error.message)
      throw error
    }
  }

  return {
    request,
    requesting,
    errorMessage,
  }
}
